import { generatePath, Navigate } from "react-router";

import type { LangCode } from "@/lib/gql/__generated__/graphql";

import { PATHS } from "@/routes/paths";

import { NewRoomEditPresenter } from "./presenter";
import { useRoomEditQuery } from "../../model/repository/new";

type Props = {
	hotelID: string;
	roomID: string | undefined;
	activeLangCode: LangCode;
};

export const NewRoomEditContainer = ({ hotelID, roomID, activeLangCode }: Props) => {
	const serverModel = useRoomEditQuery({ hotelID, roomID });

	if (!serverModel) {
		return <Navigate to={generatePath(PATHS.HOTEL.ITEMS.ROOM.TOP, { hotelID })} />;
	}

	return <NewRoomEditPresenter hotelID={hotelID} activeLangCode={activeLangCode} serverModel={serverModel} />;
};

NewRoomEditContainer.displayName = "NewRoomEditContainer";
